export default {

  GET_CATEGORIES_REQUEST: 'GET_CATEGORIES_REQUEST',
  SET_CATEGORIES: 'SET_CATEGORIES',
}
